import React, { useContext, useState, useEffect, useRef } from "react";
import { Grid, Row, Col, Tab, Tabs,Modal } from "react-bootstrap";
import InputField from "components/UI/Input/InputField"
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Card from "components/Card/Card.jsx";
import moment from 'moment';
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { FetchAPI } from "api/fetch";
import { MaterialReactTable } from 'material-react-table';
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import BeatLoader from "react-spinners/BeatLoader";
import MyExportCSV from '../components/UI/Button/ExportCSVButton';
import SimpleReactValidator from 'simple-react-validator';
import FilterBox from '../components/FilterBox/FilterBox';
import ButtonField from '../components/UI/Button/ButtonField';
import ModalBox from '../components/ModalBox/ModalBox';
import parse, { domToReact } from 'html-react-parser';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import { useTranslation } from 'react-i18next';
import { isEmpty } from "components/Login/validator";
import 'assets/css/custom.css';
import { PostAPI } from "api/post";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; 
import { getStatusAlert, transformColumns } from "utilities/CommonUtils";
import DataGrid from "components/DataGrid/DataGrid";
import PaginationDropdown from "../components/PaginationDropdown/PaginationDropdown";
import ErrorFallback from "../components/ErrorFallback/ErrorFallback.js";
import { handleNetworkErrors } from "../utilities/CommonUtils.js";
import KeyValueContainer from "components/KeyValueContainer/KeyValueContainer";
import ExpandRowGrid from "components/ExpandRowGrid/ExpandRowGrid.js";
const cookies = new Cookies();


const Role = props => {
  const root = document.documentElement;
  const MuiTableColor = getComputedStyle(root).getPropertyValue('--active__font-color').trim();
  const MuiTableTextColor = getComputedStyle(root).getPropertyValue('--button_text-color').trim();
  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout;
  let featureId = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].featureId
  let [pageLayoutData, setPageLayoutData] = useState('undefined');
  const [prop,setProp] = useState()
  let[commonTitle, setCommonTitle] = useState("");
  const [filterToExport, setFilterToExport] = useState({
    change:false,
  })
  const [showFilter, setshowFilter] = useState(false);
  const [showCSearch, setshowCSearch] = useState(false);
  const [productsData, setProductsData] = useState([]);
  const [showModal, setshowModal] = useState(false);
  const [key, setKey] = useState();
  const { t, i18n } = useTranslation();
  let [loading, setLoading] = useState(false);
  const [changeTreeValue, setChangeTreeValue] = useState(false);
  const [childRow, setChildRow] = useState(1);
  let [loadTableData, setloadTableData] = useState(true);
  const [isPageChanged, setIsPageChanged] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  let [errorMsg, setErrorMsg] = useState();
  let [error, setError] = useState(false);
  let [page, setpage] = useState(1);
  const [showTPModal, setshowTPModal] = useState(false);
  const [productsDataChild, setproductsDataChild] = useState([]);
  const [loadTableDataChild, setloadTableDataChild] = useState(true);
  const [columnsChild, setColumnsChild] = useState([]);
  const [tpPermission, setTpPermission] = useState(null);
  const [syncPermission, setSyncPermission] = useState(false)
  const [disabledButton, setDisabledButton] = useState(false);
  const [syncValue, setSyncValue] = useState(null)
  const [disableReloadIcon, setDisableReloadIcon] = useState(false)
  const [syncSapMessage, setSyncSapMessage] = useState({
    status: null,
    message: null
  })

  const textStyles = {
    fontWeight:'400',
    textAlign: "center",
  }

  const initialRenderColumns = [{
    dataField: "serial_no",
    text: "Serial No."
  },
  {
    dataField: "role_name",
    text: "Role Name"
  },
  {
    dataField: "customer_name",
    text: "Customer Name"
  }]
  const [assignedColumns, setAssignedColumns] = useState(initialRenderColumns);
  const [downloadedColumns, setDownloadedColumns] = useState(initialRenderColumns);
  const [assignedProductsData, setAssignedProductsData] = useState([]);
  const [downloadedProductsData , setDownloadedProductsData] = useState([]);
  const [assignedRecords, setAssignedRecords] = useState();
  const [downloadedRecords, setDownloadedRecords] = useState();
  let [sizePerPage, setsizePerPage] = useState(10);
  let [modalType, setmodalType] = useState(`${t("add")}`);
  let [uniqueId, setuniqueId] = useState();
  let [extraId, setextraId] = useState();
  let [searchInputValue, setsearchInputValue] = useState('');
  let [modalgetURL, setmodalgetURL] = useState('');
  let [localPageLoadIndicator, setLocalPageLoadIndicator] = useState(globalLoadIndicator);
  let [dropDownApi, setDropDownApi] = useState();
  let [isChecked, setIschecked] = useState(true);
  let [saveUrl, setSaveUrl] = useState();
  let [addButtonPermission, setAddButtonPermission] = useState(false);
  let [showParentContent, setShowParentContent] = useState(true);
  let [selectChildValue, setSelectChildValue] = useState([]);
  let [iotQty, setIotQty] = useState();
  let [downloaded, setDownloaded] = useState();
  let [assigned, setAssigned] = useState();
  let [modalTitle, setModalTitle] = useState('');
  let [modalWidth, setModalWidth] = useState();
  let [imagePath, setImagePath] = useState();
  let [table, setTable] = useState(false);
  let [headers, setHeaders] = useState(null);
  let [values, setValues] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectOption, setSelectOption] = useState(0);
  const [pageStartFrom, setPageStartFrom] = useState(1);
  const [totalrecords, settotalrecords] = useState();
  const [timeStamp, setTimeStamp] = useState("");
  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',
    }
  ];
   const filteredExport2 = (data) =>{
    setValues(data);
   }
  const searchContainerRef = useRef(null);
 
  let [formValues, setformValues] = useState();
  let [FilterformValues, setFilterformValues] = useState();
  let [ModalformValues, setModalformValues] = useState();
  const [expandedRows, setExpandedRows] = useState([]);
  const [poInputChange, setPoInputChange] = useState("");
  const [poInput, setPoInput] = useState("");
  const [hasError, setHasError] = useState({
    error: false,
    message: ""
  })
  const [paginationAssigned, setPaginationAssigned] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [paginationDownloaded, setPaginationDownloaded] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
  const language = currentLanguageCode === 'en' ? 'english' : 'chinese'

  let dynamicParameters = {
   user_id:cookies.get('user_id'),
   customer_id:cookies.get('customer_id'),
   userLocation_id:cookies.get('userLocation_id'),
   userRole_name:cookies.get('userRole_name'),
    language: language
   }

  const validator = new SimpleReactValidator({
    autoForceUpdate: this,
    element: (message, className) => <div className="text-danger">{message}</div>
  });

  const formElementsArray = [];
  if(ModalformValues){
    for (let key in ModalformValues) {
      formElementsArray.push({
        id: key,
        config: ModalformValues[key]
      });
    }
  }
  
  const inputChangedHandler = (event, inputIdentifier) => {
    try{
    const updateOrderForm = {
      ...formValues
    }
    const updateElemetForm = {
      ...updateOrderForm[inputIdentifier]
    };

    updateElemetForm.value = event.target.value;
    updateOrderForm[inputIdentifier] = updateElemetForm;
    setformValues(updateOrderForm);
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

 
  async function searchTableData(data) {
    try{
    setloadTableData(false);
    let startFrom = 0;
    let cpage = 0
    let searchFormData = {};
    let modifiedTab;
    let totalParams = { ...dynamicParameters };
      if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
        totalParams = {
          ...totalParams,
          ...(pageLayoutData[1].subComponentsItems.extraParameters || {}),
        }
      }
    switch(key){
      case pageLayoutData[1].subComponentsItems.tabName1:
      default:
        totalParams = { ...totalParams, mode: key }
        break;
      case pageLayoutData[1].subComponentsItems.tabName2:
        totalParams = { ...totalParams, mode: key }
        break;
    }
    totalParams = {...totalParams, ...dynamicParameters };
    if(formValues){    
    for (let formElementIdentifier in data) {
       if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
  }
    // if(page == 1) {
    //   let startFrom = 0;
      totalParams.start_from = startFrom;
    // }else {
    //   cpage = page -1;
    //   startFrom = cpage * sizePerPage;
    //   totalParams.start_from = startFrom;
    // }
    let newObj = { ...searchFormData, ...totalParams}
    setpage(1);
    if(!setsearchInputValue || searchInputValue === undefined );
    else
     newObj = {...newObj, 'element': searchInputValue}
     tabChangeHandler(key, newObj);
     setPageStartFrom(1);
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  async function filteredExport(data) {
    try{
    let searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[0].exportApiEndPoint;
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name')
    }
    totalParams = {...totalParams, ...requiredValues}
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    for (let formElementIdentifier in data) {
      if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
    let newObj = { ...searchFormData, ...totalParams}
    let responseData;
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
    }else {
      responseData = await PostAPI(getURL, newObj);
      handleNetworkErrors(responseData,setHasError);
    }
    if(responseData.status == 200){
      swal('Your request is under process',
          'Shortly, you will receive an email with downlodable link','success')
      //window.location.href = "https://tertiary-label-printing.s3.amazonaws.com/OrientReports/2020-10-27/ProductionReport.xlsx";
      }
      else{
        swal('Something went wrong','Please download again','error')
      }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}


  async function filteredExport1(data) {
    try{
    let searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[0].exportApiEndPoint1;
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name')
    }
    totalParams = {...totalParams, ...requiredValues}
    // let getURL = pageLayoutData[0].exportApiEndPoint1+'?customer_id='+cookies.get('customer_id') 
    // + '&user_id='+ cookies.get('user_id')+ '&email='+ localStorage.getItem('email');
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    for (let formElementIdentifier in data) {
      if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
    let newObj = { ...searchFormData, ...totalParams, report_name: pageLayoutData[1].title1}
    let responseData;
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
    }else {
      responseData = await PostAPI(getURL, newObj);
      handleNetworkErrors(responseData,setHasError);
    }
    if(responseData.status == 200){
      if(responseData?.data?.status === 1){
        swal({
          icon: "success",
          title: "Success",
          text: responseData.data.message
        })
        return;
      }
      swal('Your request is under process',
          'Shortly, you will receive an email with downlodable link','success')
      }
      else{
        swal('Something went wrong','Please download again','error')
      }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}


  async function clearTableData(event) {
    try{
   // event.preventDefault();
    setValues()
    setloadTableData(false)
    setshowFilter(!showFilter);
    let getURL;
    let totalParams = { ...dynamicParameters };
    if (pageLayoutData[1].subComponentsItems.extraParameters || pageLayoutData[1].subComponentsItems.firstTimeParameters) {
      totalParams = {
        ...totalParams,
        ...(pageLayoutData[1].subComponentsItems.extraParameters || {}),
        ...(pageLayoutData[1].subComponentsItems.firstTimeParameters || {})
      }
    }
    setSelectedValue(1)
    setPageStartFrom(1)
    switch (key) {
      case pageLayoutData[1].subComponentsItems.tabName1:
        default:
        getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
        totalParams = { ...totalParams, mode: key }
        break;
      case pageLayoutData[1].subComponentsItems.tabName2:
        getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
        totalParams = { ...totalParams, mode: key }
        break;
    }
    if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined );
      else
      setIsLoading(true);
      getURL = getURL + '&element=' + searchInputValue;
      let responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        setProductsData(responseDataJson.data.data)
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
          }
        }
        setpage(1);
        setPageStartFrom(1)
        setIsLoading(false);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );

        if (key === pageLayoutData[1].subComponentsItems.tabName1) {
          setAssignedColumns(responseDataJson.data.columns);
          setAssignedProductsData(responseDataJson.data.data);
          setAssignedRecords(responseDataJson.data.recordsTotal);
        } else {
          setDownloadedColumns(responseDataJson.data.columns);
          setDownloadedProductsData(responseDataJson.data.data);
          setDownloadedRecords(responseDataJson.data.recordsTotal);
        }
        setformValues(pageLayoutData[0].formValues);
        setIotQty(pageLayoutData[1].title1 === 'Assign' ?responseDataJson.data.IOTQty : responseDataJson.data.availableQty)
        setDownloaded(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName2') && pageLayoutData[1].subComponentsItems.tabName2.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName2.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName2}Qty`])
        setAssigned(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName1') && pageLayoutData[1].subComponentsItems.tabName1.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName1.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName1}Qty`]);
        setshowFilter(!showFilter);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setIsLoading(false);
        setError(true);
        setErrorMsg('Oops..! Something went wrong.');
      }  
    }else {
      const response = await PostAPI(getURL, totalParams)
      if (key === pageLayoutData[1].subComponentsItems.tabName1) {
        setAssignedColumns(response.data.data.columns);
        setAssignedProductsData(response.data.data.data);
        setAssignedRecords(response.data.data.recordsTotal);
      } else {
        setDownloadedColumns(response.data.data.columns);
        setDownloadedProductsData(response.data.data.data);
        setDownloadedRecords(response.data.data.recordsTotal);
      }
      if (!isEmpty(response.data.data)) {
        if (pageLayoutData[0].addButtonType == 'modal') {
          modalActions(response.data.data);
        }
      }
      setformValues(pageLayoutData[0].formValues);
      setloadTableData(true)
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const handleGlobalSearch = async (input) => {
    setsearchInputValue(input)
    setIsLoading(true);
    setloadTableData(false);
    let totalParams;
    let startFrom = 0;
    let searchFormData = {};
    let getURL
    switch (key) {
      case pageLayoutData[1].subComponentsItems.tabName1:
        default:
        getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
        break;
      case pageLayoutData[1].subComponentsItems.tabName2:
        getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
        break;
    }
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    } 
    totalParams = { ...totalParams, mode: key }
    totalParams= {...totalParams, start_from: startFrom, ...dynamicParameters}
    totalParams = {...totalParams, element:input.replace(/^\s+|\s+$/gm,'')}
    let newObj = { ...searchFormData, ...totalParams}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        modalActions(responseDataJson.data)
        setpage(1);
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
              setAssignedColumns(responseDataJson.data.columns); 
              setAssignedProductsData(responseDataJson.data.data);
              setAssignedRecords(responseDataJson.data.recordsTotal)
              setAssigned(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName1') && pageLayoutData[1].subComponentsItems.tabName1.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName1.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName1}Qty`])
              break;
              case pageLayoutData[1].subComponentsItems.tabName2:
                setDownloadedColumns(responseDataJson.data.columns); 
                setDownloadedProductsData(responseDataJson.data.data)
                setDownloadedRecords(responseDataJson.data.recordsTotal)
                setDownloaded(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName2') && pageLayoutData[1].subComponentsItems.tabName2.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName2.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName2}Qty`])
            break;
        }
        setSelectedValue(1);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setformValues(pageLayoutData[0].formValues);
        setshowCSearch(true);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let responseData = await PostAPI(getURL, newObj);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        setpage(1);
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
              setAssignedColumns(responseDataJson.data.columns); 
              setAssignedProductsData(responseDataJson.data.data);
              setAssignedRecords(responseDataJson.data.recordsTotal)
              break;
              case pageLayoutData[1].subComponentsItems.tabName2:
                setDownloadedColumns(responseDataJson.data.columns); 
                setDownloadedProductsData(responseDataJson.data.data)
                setDownloadedRecords(responseDataJson.data.recordsTotal)
            break;
        }
        setSelectedValue(1);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setformValues(pageLayoutData[0].formValues);
        setshowCSearch(true);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
    setIsLoading(false);
  }


  async function handleClearSearch() {
    setIsLoading(true);
    setloadTableData(false);
    let totalParams;
    let startFrom= 0;
    let cpage;
    let searchFormData={};
    let getURL
    switch (key) {
      case pageLayoutData[1].subComponentsItems.tabName1:
        default:
        getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
        break;
      case pageLayoutData[1].subComponentsItems.tabName2:
        getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
        break;
    }
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }     
      totalParams = { ...totalParams, mode: key }
      totalParams = {...totalParams, start_from: startFrom}
    for (let formElementIdentifier in formValues) {
      if(formValues[formElementIdentifier].elementType === 'multiselect') {
        if((formValues[formElementIdentifier].value)) {
          let arrayConvert = [];
          formValues[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else
        searchFormData[formElementIdentifier] = formValues[formElementIdentifier].value;
    }
    totalParams = {...totalParams, ...dynamicParameters, ...searchFormData}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      setsearchInputValue();
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        modalActions(responseDataJson.data)
        setpage(1);
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
              setAssignedColumns(responseDataJson.data.columns); 
              setAssignedProductsData(responseDataJson.data.data);
              setAssignedRecords(responseDataJson.data.recordsTotal)
              break;
              case pageLayoutData[1].subComponentsItems.tabName2:
                setDownloadedColumns(responseDataJson.data.columns); 
                setDownloadedProductsData(responseDataJson.data.data)
                setDownloadedRecords(responseDataJson.data.recordsTotal)
            break;
        }
        setSelectedValue(1);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setformValues(pageLayoutData[0].formValues);
        setsearchInputValue();
        setshowCSearch(false);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
     setsearchInputValue();
      let responseData = await PostAPI(getURL, totalParams);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        setpage(1);
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
              setAssignedColumns(responseDataJson.data.columns); 
              setAssignedProductsData(responseDataJson.data.data);
              setAssignedRecords(responseDataJson.data.recordsTotal)
              break;
              case pageLayoutData[1].subComponentsItems.tabName2:
                setDownloadedColumns(responseDataJson.data.columns); 
                setDownloadedProductsData(responseDataJson.data.data)
                setDownloadedRecords(responseDataJson.data.recordsTotal)
            break;
        }
        setSelectedValue(1);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setformValues(pageLayoutData[0].formValues);
        setsearchInputValue();
        setshowCSearch(false);
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
  setIsLoading(false);
  setPaginationAssigned({
    pageIndex: 0,
    pageSize: 10,
  });
  setPaginationDownloaded({
    pageIndex: 0,
    pageSize: 10,
  })
  };


  async function handleLatestTableData(page) {
    try{
    setloadTableData(false);
    setIsPageChanged(true);
    setIsLoading(true);
    let startFrom = 0;
    let cpage = 0
    const searchFormData = {};
    let totalParams;
    let getURL
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
            getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
            break;
          case pageLayoutData[1].subComponentsItems.tabName2:
            getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
            break;
        }
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    totalParams = {...totalParams, ...dynamicParameters}
    totalParams = {...totalParams, mode :`${key}`}
    for (let formElementIdentifier in values) {
      if(values[formElementIdentifier].elementType === 'multiselect') {
        if((values[formElementIdentifier].value)) {
          let arrayConvert = [];
          values[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else
        searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
    }
    if(page == 0) {
      totalParams.start_from = 0;
    }else {
      if(key === pageLayoutData[1].subComponentsItems.tabName1){
        totalParams.start_from = paginationAssigned.pageSize * paginationAssigned.pageIndex;
      }else{
        totalParams.start_from = paginationDownloaded.pageSize * paginationDownloaded.pageIndex;
      }
    }
    let newObj = { ...searchFormData, ...totalParams}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined ){
      getURL = getURL + '&index=' + page;
      }
      else{
      getURL = getURL + '&element=' + searchInputValue+'&index=' + page;
      }
      let responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        setProductsData(responseDataJson.data.data)
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
          }
        }
        if (key === pageLayoutData[1].subComponentsItems.tabName1) {
          setAssigned(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName1') && pageLayoutData[1].subComponentsItems.tabName1.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName1.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName1}Qty`])
          setAssignedColumns(responseDataJson.data.columns);
          setAssignedProductsData(responseDataJson.data.data);
          setAssignedRecords(responseDataJson.data.recordsTotal);
        } else {
          setDownloaded(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName2') && pageLayoutData[1].subComponentsItems.tabName2.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName2.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName2}Qty`])
          setDownloadedColumns(responseDataJson.data.columns);
          setDownloadedProductsData(responseDataJson.data.data);
          setDownloadedRecords(responseDataJson.data.recordsTotal);
        }
        setloadTableData(true);
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('Oops..! Something went wrong.');
      }
    }else {
      const response = await PostAPI(getURL, newObj)
      if (key === pageLayoutData[1].subComponentsItems.tabName1) {
        setAssignedColumns(response.data.data.columns);
        setAssignedProductsData(response.data.data.data);
        setAssignedRecords(response.data.data.recordsTotal);
      } else {
        setDownloadedColumns(response.data.data.columns);
        setDownloadedProductsData(response.data.data.data);
        setDownloadedRecords(response.data.data.recordsTotal);
      }
    }
    setloadTableData(true);
    setIsLoading(false);
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  async function getLatestTableData() {
    try{
    setformValues(pageLayoutData[0].formValues);
    setshowFilter(false)
    setloadTableData(false);
    setsearchInputValue('');
    setshowCSearch(false);
    let totalParams;
    let getURL
        switch (key) {
          case pageLayoutData[1].subComponentsItems.tabName1:
            default:
            getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1
            break;
          case pageLayoutData[1].subComponentsItems.tabName2:
            getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2
            break;
        }
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      totalParams = {...totalParams, ...firstTimeParameters}
    }
    totalParams = {...totalParams, ...dynamicParameters}
    totalParams = {...totalParams,mode :`${key}`}

    if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      getURL = getURL + '&index=' + page;
      // if(!setsearchInputValue || searchInputValue === undefined )
      // getURL = getURL;
      // else
      // getURL = getURL + '&element=' + searchInputValue;
      let responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        setProductsData(responseDataJson.data.data)
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
          }
        }
        setpage(1);
        setPageStartFrom(1);
        if (key === pageLayoutData[1].subComponentsItems.tabName1) {
          setAssignedColumns(responseDataJson.data.columns);
          setAssignedProductsData(responseDataJson.data.data);
          setAssignedRecords(responseDataJson.data.recordsTotal);
        } else {
          setDownloadedColumns(responseDataJson.data.columns);
          setDownloadedProductsData(responseDataJson.data.data);
          setDownloadedRecords(responseDataJson.data.recordsTotal);
        }
        setIotQty(pageLayoutData[1].title1 === 'Assign' ?responseDataJson.data.IOTQty : responseDataJson.data.availableQty)
        setDownloaded(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName2') && pageLayoutData[1].subComponentsItems.tabName2.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName2.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName2}Qty`])
        setAssigned(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName1') && pageLayoutData[1].subComponentsItems.tabName1.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName1.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName1}Qty`]);
        setloadTableData(true);
        setSelectedValue(1); 
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('Oops..! Something went wrong.');
      }  
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  async function delelteData(URL) {
    try{
    const getresponse = await FetchAPI(URL);
    handleNetworkErrors(getresponse,setHasError);
    const getresponseJson = await getresponse.json();
    const responseData = getresponseJson.data;
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const openFilter = () => {
    try{
    setFilterToExport(prevState => {
      return {
        ...prevState,
        change:false
      }
    })
    setshowFilter(!showFilter);
    let URL= pageLayoutData[0].hasOwnProperty('filterEndPoint') ? 
            pageLayoutData[0].filterEndPoint: 'not found'
    let totalParams={};
    if(pageLayoutData[0].extraParametersDropdown !== null) {
      const extraParametersDropdown = pageLayoutData[0].extraParametersDropdown;
      totalParams = {...totalParams, ...extraParametersDropdown}
      let modifiedTab;
    switch(key){
      case pageLayoutData[1].subComponentsItems.tabName1:
      default:
        modifiedTab = pageLayoutData[1].subComponentsItems.tabName1.replace(/\s/g, '')
        totalParams = { ...totalParams, mode: modifiedTab }
        break;
      case pageLayoutData[1].subComponentsItems.tabName2:
        modifiedTab = pageLayoutData[1].subComponentsItems.tabName2.replace(/\s/g, '')
        totalParams = { ...totalParams, mode: modifiedTab }
        break;
    }

    }
    totalParams = {...totalParams, ...dynamicParameters}
    if(URL !== 'not found') {
    let paramsConverted = new URLSearchParams(totalParams);
    URL = (`${URL}?${paramsConverted.toString()}`);
    setDropDownApi(URL);
    }else 
    setDropDownApi('not found')
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const open = () => {
    try{
    setuniqueId();
    setModalWidth("modal-55w")// setModalWidth(pageLayoutData[0].addButtonItems.className);
    setmodalType(!(pageLayoutData[1].title2 === 'Bulk Download') && `${t("add")}`);
    setModalTitle(pageLayoutData[0].addButtonName);
    setCommonTitle(pageLayoutData[0].addButtonName)
    // i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addButtonNameEn) : setCommonTitle(pageLayoutData[0].addButtonName)
    setModalformValues(pageLayoutData[0].addButtonItems.formValues);
    setSaveUrl(pageLayoutData[0].addButtonItems.saveApiEndPoint);
    setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language);
    setshowModal(true);
    (pageLayoutData[0].addButtonItems.hasOwnProperty('Table') ? 
        setTable(pageLayoutData[0].addButtonItems.Table) : 
        setTable(false));
      (pageLayoutData[0].addButtonItems.hasOwnProperty('headers') ? 
          setHeaders(pageLayoutData[0].addButtonItems.headers) : 
          setHeaders(null));
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const openImport = () => {
    try{
    setmodalType(`${t("import")}`);
    setModalTitle(pageLayoutData[0].importButtonName);
    setModalformValues(pageLayoutData[0].importButtonItems.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems.saveApiEndPoint);
    setshowModal(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const openImport1 = () => {
    try{
    setmodalType(`${t("import")}`);
    setModalTitle(pageLayoutData[0].importButtonName1);
    setModalformValues(pageLayoutData[0].importButtonItems1.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems1.saveApiEndPoint);
    setshowModal(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const close = () => {
    setshowModal(false);
  }

  const editOpenModal = (event, id, extraId) => {
    try{
    setModalTitle(pageLayoutData[0].addButtonName);
    (pageLayoutData[0].editButtonItems !== undefined ? setModalformValues(pageLayoutData[0].editButtonItems.formValues) : setModalformValues(pageLayoutData[0].addButtonItems.formValues));
    setSaveUrl(pageLayoutData[0].addButtonItems.saveApiEndPoint);
    let editURL = '';

      editURL = pageLayoutData[1].subComponentsItems.getApiEndPoint+ 
      '?id=' +id+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
      setmodalgetURL(editURL);
      setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id'));
    // }
    // (pageLayoutData[0].editButtonItems !== undefined ? setModalformValues(pageLayoutData[0].editButtonItems.formValues) : setModalformValues(pageLayoutData[0].addButtonItems.formValues));
    setModalWidth("modal-55w")// setModalWidth(pageLayoutData[0].editButtonItems.className);
    setmodalType(`${t('edit')}`);
    setuniqueId(id);
    setextraId(extraId);
    setshowModal(true);
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}


  async function exportOpenModal (e, value)  {
    try{
    e.preventDefault();
    setmodalType('');
    setuniqueId(value.id)
    setModalTitle(pageLayoutData[0].addTextName);
    setModalWidth("modal-55w")// setModalWidth(pageLayoutData[0].addTextItems.className);
    setModalformValues(pageLayoutData[0].addTextItems.formValues);
    setshowModal(true);
    setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id')+'&user_id='+cookies.get('user_id'));
    setSaveUrl(pageLayoutData[0].addTextItems.exportEndPoint)
    setshowModal(true);
    (pageLayoutData[0].addTextItems.hasOwnProperty('Table') ? 
        setTable(pageLayoutData[0].addTextItems.Table) : 
        setTable(false));
    (pageLayoutData[0].addTextItems.hasOwnProperty('headers') ? 
        setHeaders(pageLayoutData[0].addTextItems.headers) : 
        setHeaders(null));
} catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
  }


async function exportResModal (e, value)  {
  try{
  e.preventDefault();
  setProp(value.download_token)
  setmodalType('');
  setuniqueId(value.po_number)
  setModalTitle(pageLayoutData[0].addTextName1);
  setCommonTitle(pageLayoutData[0].addTextName1)
  // i18n.language === "chi" ? setCommonTitle(pageLayoutData[0].addTextName1En) : setCommonTitle(pageLayoutData[0].addTextName1)
  setModalWidth("modal-55w")// setModalWidth(pageLayoutData[0].addTextItems1.className);
  setModalformValues(pageLayoutData[0].addTextItems1.formValues);
  setshowModal(true);
  if (pageLayoutData[0].addTextName1 === 'Download Reclamation PO') {
    setSaveUrl(pageLayoutData[0].addTextItems1.exportEndPoint1 + '?customer_id=' + cookies.get('customer_id') + "&id=" + value.po_number + '&user_id=' + cookies.get('user_id') + '&email=' + localStorage.getItem('email')
      + '&userLocation_id=' + cookies.get('userLocation_id') + '&userRole_name=' + localStorage.getItem('userRole_name') + '&language=' + language)
  } else {
    setSaveUrl(pageLayoutData[0].addTextItems1.exportEndPoint1 + '?customer_id=' + cookies.get('customer_id') + (featureId === 1 ? cookies.get('customer_id') == "15" ? "&id=" + value.id : "&id=" + value.po_number : "&id=" + value.download_token)
      + '&user_id=' + cookies.get('user_id') + '&email=' + localStorage.getItem('email')
      + '&userLocation_id=' + cookies.get('userLocation_id') + '&userRole_name=' + localStorage.getItem('userRole_name') + '&language=' + language)
  }
} catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}

const updateGridRecord = async(id, status) => {
  setloadTableData(false)
    const updatedGridData = productsData.map(data => {
      if(id === data.id){
        data.reload = status
        data.sync_time = moment().format('YYYY-MM-DD HH:mm:ss')
        data.status = status === 1 ? "Synced" : "Sync failed"
        data.type = "Manual"
        data.action = <div className="action-styles" >
        {<i onClick={(e) => handleSyncToSap(data)} className={`fa fa-info-circle refresh-icon ${status == 2 || status == 0 ? "refresh-warn" : ""}`}/>}
        {(status == 0 || status == 2)&& <i onClick={(e) => handleSyncReload(data)} className={`fa fa-refresh refresh-icon`} />} 
      </div>
      }
      return data
    })
    setloadTableData(true) 
    setProductsData(updatedGridData)
}

const getSyncReload = async(value) => {
  try{
  const payloadObj = {
    id: value.id,
    delivery_id: value.delivery_id,
    reload: value.reload
  }
  setIsLoader(true)
  setIsLoading(true)
  const response = await PostAPI(pageLayoutData[1].subComponentsItems.saveApiEndPoint,payloadObj)
  handleNetworkErrors(response,setHasError);
  if(response.status === 200){
    setDisableReloadIcon(false)
    setIsLoader(false)
    setIsLoading(false)
    getStatusAlert({status:response?.data?.Status,message: response?.data?.Message})
    updateGridRecord(value.id,response?.data?.Status)
  }else{
    setDisableReloadIcon(false)
    setIsLoader(false)
    setIsLoading(false)
    getStatusAlert({status: 404,message:`${t("alerts.something_went_wrong1")}`,buttonText:`${t("alerts.ok")}`})
  }
}catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}

useEffect(() => {
  try {
    if (disableReloadIcon && syncValue !== null) {
      getSyncReload(syncValue)
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}, [disableReloadIcon, syncValue])

const closeTPModal = () => {
  setshowTPModal(false);
}

async function syncInventory(e) {
  try{
  let getURL = pageLayoutData[1].subComponentsItems.syncApiEndPoint
  const customerId = cookies.get('customer_id');
  const location_id = cookies.get('userLocation_id');
  const user_role_name = cookies.get('userRole_name');
  const user_id = cookies.get('user_id');
  if(customerId == 15){
    const payload = {
      location_id,
      user_role_name,
      user_id
    }
    const paramsConverted = new URLSearchParams(payload);
    getURL = (`${getURL}?${paramsConverted.toString()}`);
  }
  setIsLoader(true)
  setIsLoading(true)
  setDisabledButton(true)
  let responseData = await FetchAPI(getURL);
  handleNetworkErrors(responseData,setHasError);
  if(responseData.status === 200){
    let getresponseJson = await responseData.json()
    setDisabledButton(false)
    setIsLoader(false)
    setIsLoading(false)
    getStatusAlert({status: getresponseJson?.Status,message: getresponseJson?.data,reCallGrid: getLatestTableData})
  }else{
    setDisabledButton(false)
    setIsLoader(false)
    setIsLoading(false)
    getStatusAlert({status: 404,message:`${t("alerts.something_went_wrong1")}`,buttonText:`${t("alerts.ok")}`})
  }
} catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}

const getSyncToSapGridColumns = (data) => {
  try{
    const columns = data.map(column => {
      let arr = []
      for (let key in column) {
      let data_key = pageLayoutData[1].title1 === "Internal Quality Check" ? key.toLowerCase() : key
      let keyText = key.split("_").join(" ").toUpperCase()
      arr.push({ dataField: data_key, text: keyText})
    }
    return [...arr]
  })
  setColumnsChild(columns[columns.length - 1]);
}catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}
const modifySyncToSapJson = (inputJson) => {
  try{
  const title = pageLayoutData[1].title1;
  if (cookies.get('customer_id') == 15 || cookies.get('customer_id') == 17) {
    let Del_no, Plant, From_storageloc, Rec_storageloc
    if (title === "Dispatch Sync to" || title === "Receive GRN to") {
      const { del_no, plant } = inputJson[0];
      Del_no = inputJson[0]?.Out_delv_no ? inputJson[0]?.Out_delv_no : del_no;
      Plant = inputJson[0]?.Rec_plant ? inputJson[0]?.Rec_plant : plant;
    } else if (title === "Inventory Sync to") {
      const { plant, from_storageloc, rec_storageloc } = inputJson[0];
      Plant = plant;
      From_storageloc = from_storageloc;
      Rec_storageloc = rec_storageloc;
    }else if(title === "Internal"){
      Plant = inputJson.Plant;      
    }
    let data;
    if(title === "Internal"){
      data = inputJson?.ItemSet
    }else if(title === "Receive GRN to"){
      data = inputJson[0].ItemSet
    }else if(title === "Production"){
      data = inputJson
    }
    else{
      data = inputJson[0]?.data
    }
    const mergedData = data.map(item => {
      if (title === "Dispatch Sync to" || title === "Receive GRN to") {
        return {
          ...item,
          Del_no,
          Plant
        }
      } else if (title === "Internal") {
        const { Prod_order, Material, From_storageloc, Rec_storageloc, Quantity, Uom } = item
        return {
          Plant,
          Prod_order,
          Material,
          From_storageloc,
          Rec_storageloc,
          Quantity,
          Uom
        }
      }else if(title === "Production"){
        return {
          ...item
        }
      }
      return {
        ...item,
        Plant,
        From_storageloc,
        Rec_storageloc,
      }
    });
    getSyncToSapGridColumns(mergedData)
    return mergedData
  } else {
    getSyncToSapGridColumns(inputJson)
    let modifiedJSON = inputJson.map((el) => {
      return Object.keys(el).reduce((acc, key) => {
        acc[key.toLowerCase()] = el[key];
        return acc;
    }, {});
  }) 
    return modifiedJSON;
  }

}catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}

  const handleIQCApprove = async (value) => {
    try {
      const payload = {
        ...dynamicParameters,
        grant_approval: 1,
        grn_number: value.grn_number,
        location_name: value.location_name
      }
      let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint2;
      const paramsConverted = new URLSearchParams(payload);
      getURL = `${getURL}?${paramsConverted.toString()}`;
      const response = await FetchAPI(getURL);
      const responseJson = await response.json();
      if (responseJson?.data?.status === 1) {
        swal({ icon: "success", title: "Success", text: responseJson.data.message })
        getLatestTableData();
      } else {
        swal({ icon: "error", title: "Something went wrong!" })
      }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const handleIQCReject = async (e,value) => {
    try{
      e.preventDefault();
      setmodalType('');
      setModalTitle(pageLayoutData[0].addTextName1);
      setCommonTitle(t(pageLayoutData[1].subComponentsItems.apiTabName2))
      setModalWidth("modal-55w")// setModalWidth(pageLayoutData[0].addTextItems1.className);
      setModalformValues(pageLayoutData[0].addTextItems1.formValues);
      setshowModal(true);
      const payload = {
        ...dynamicParameters,
        grant_approval: 2,
        grn_number: value.grn_number,
        location_name: value.location_name
      }
      const paramsConverted = new URLSearchParams(payload);
      setSaveUrl(`${pageLayoutData[0].addTextItems1.exportEndPoint1}?${paramsConverted.toString()}`)
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

const handleSyncReload = async(value) => {
  setSyncValue(value);
  setDisableReloadIcon(true);
}

const handleSyncToSap = (value) => {
  try{
  setSyncSapMessage({
    status: value?.status,
    message: value?.message
  })
  let inputJson = JSON.parse(value.input)
  if(!Array.isArray(inputJson)){
    inputJson = [inputJson]
  }
  const result = modifySyncToSapJson(inputJson)
  setproductsDataChild(result);
  setModalTitle("List");
  setloadTableDataChild(true);
  setshowTPModal(true);
} catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}
 
  const deleteOpenModal = (event, value) => {
    try{
    let uniqueId = '';
    let delURL = '';
      uniqueId = value.id;
      delURL = pageLayoutData[1].subComponentsItems.deleteApiEndPoint + '?id=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    // }
    let msg = '';
    swal({title:`${t("alerts.sure")}`, text:`${t("alerts.deleted_not_recovered")}`, icon:"warning", buttons: true, dangerMode: true,}) 
    // swal({
    //   title: "Are you sure?",
    //   text: "Once deleted, you will not be able to recover this data!",
    //   icon: "warning",
    //   buttons: true,
    //   dangerMode: true,
    // })
    .then((willDelete) => {
      if (willDelete) {
        delelteData(delURL);
        swal("Poof! Your data has been deleted!", {
          icon: "success",
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } else {
        swal("Your data is safe!", {
          timer: 2000,
          button: false
        });
      }
    });
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  const handleDownloadIots = (value) => {
    try{
      window.location.href = value.download_file_path;
    }catch(e){
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const handleDownload = async(value) => {
    let endpoint = pageLayoutData[1].subComponentsItems.exportEndPoint;
    let newObj = { ...dynamicParameters, id: value.name, mode: key }
    if(pageLayoutData[1].title1 === "PO INSPECT"){
      newObj = {...newObj, delivery_id: value.name}
    }else if (pageLayoutData[1].title1 === "QC"){
      newObj = {...newObj, grn_number: value.GRN_number,lot_number: value.lot_number,email:localStorage.getItem('email')}
    }
    let paramsConverted = new URLSearchParams(newObj);
    endpoint = (`${endpoint}?${paramsConverted.toString()}`);
    setIsLoader(true);
    const response = await FetchAPI(endpoint);
    const responseJson = await response.json()
    if(responseJson?.data?.Status == 409){
      swal(responseJson?.data?.Message)
      return;
    }
    setIsLoader(false);
    window.location.href = responseJson.data.data 
  }

  const handleReportActions = async(value, type) => {
    try{
    let payload;
    switch(type){
      case "download":
        if(value.status === "Processing"){
          getStatusAlert({status: 3,message: "Please wait...We are processing your request.",reCallGrid: getLatestTableData})
          return;
        }
        window.location.href = value.s3_link;
        break;
      case "mail":
        let getURL = pageLayoutData[1]?.subComponentsItems?.apiEndPoint3
        payload = {...dynamicParameters, id: value.id, email: localStorage.getItem('email')}
        const paramsConverted = new URLSearchParams(payload);
        getURL = (`${getURL}?${paramsConverted.toString()}`);
        setIsLoader(true)
        setIsLoading(true)
        const response = await FetchAPI(getURL);
        handleNetworkErrors(response,setHasError);
        const responseJson = await response.json();
        if(response.status === 200){
          getStatusAlert({status: responseJson?.data?.status,message: responseJson?.data?.message})
          setIsLoader(false)
          setIsLoading(false)
        }else{
          setIsLoader(false)
          setIsLoading(false)
          getStatusAlert({status: 404,message:`${t("alerts.something_went_wrong1")}`,buttonText:`${t("alerts.ok")}`})
        }
        break;
      default:
        return;
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const TippyIcon = ({onClick,iconClass,tooltipText}) => (
    <Tippy
      content={tooltipText}
      appendTo={document.body}
      placement="top"
      offset={[0, 10]}
      animation="shift-toward"
      theme="custom"
    ><i onClick={onClick} className={iconClass} />
    </Tippy>
  );
  
  
  async function modalActions(data){
    try{
      const modules = ["Inventory Sync to","Internal","Internal Quality Check","Receive GRN to","Production"];
      const IsSyncToSap = modules.includes(pageLayoutData[1].title1);
      const titles = ["Download Serial Number","Download Reclamation PO","Download Buffer IOT's"]
      const isDownloadSerialNumber = ((cookies.get('customer_id') === '12') && (titles.includes(pageLayoutData[0].addTextName1)))
      let tabKey = key
    for (let [key, value] of Object.entries(data.data)) {
      value.action = <div className="action-styles" >
            {data.editPermission == true ? <a onClick={ (e) => editOpenModal(e, value.id) }><i className="fa fa-pencil-square-o fa-edit"></i></a>: ''}
            {tabKey === 'bulk download' && pageLayoutData[1].title2 === 'Bulk Download' &&
             <i style={{ cursor: 'pointer' }} 
              onClick={() => window.location.href = value.filename}className="fa fa-download-square-o fa-download">
             </i>}
          {(isDownloadSerialNumber && ("download_file_path" in value && value.download_file_path)) && <i onClick={() => handleDownloadIots(value)} className="fa fa-download-square-o fa-download refresh-icon"></i>}   
          {(!isDownloadSerialNumber && cookies.get('customer_id') === '12' &&
          (value.download == true && value?.download_token ?
            pageLayoutData[1].title2 === 'Serial Number' ?
              value.status === 'Ready to download' ?
                <a onClick={(e) => exportResModal(e, value)}>
                  <i className="fa fa-download-square-o fa-download"></i>
                </a> : <i style={{ cursor: 'pointer' }} onClick={(() => handleReportActions(value, "download"))} className="fa fa-refresh"></i> : <a onClick={(e) => exportResModal(e, value)}>
                <i className="fa fa-download-square-o fa-download"></i>
              </a> : " "))}
            {value.download && pageLayoutData[0].reportFlag && <i onClick={(() => handleReportActions(value,"download"))} className={`fa fa-download-square-o fa-download refresh-icon ${value.status === "Ready to download" ? "processed" : "processing"}`} />}
            {value.mail && pageLayoutData[0].reportFlag && <i onClick={(() => handleReportActions(value,"mail"))} className={`fa fa-envelope refresh-icon ${value.status === "Ready to download" ? "" : "processing-mail"}`} />}
            {data.deletePermission == true ? <a onClick={ (e) => deleteOpenModal(e, value) }><i className="fa fa-trash-o fa-delete"></i></a>: ''}
            {(IsSyncToSap && (!pageLayoutData[0]?.reportFlag)) && <i onClick={(e) => handleSyncToSap(value)} className={`fa fa-info-circle refresh-icon ${value.reload == 2 ? "refresh-warn" : ""}`}/>}
        {((value.reload == 0 || value.reload == 2) && (pageLayoutData[1].title1 === "Dispatch Sync to"
          || ((pageLayoutData[1].title1 === "Receive GRN to" || pageLayoutData[1].title1 === "Inventory Sync to" || pageLayoutData[1].subComponentsItems.isSync) && (cookies.get('customer_id') == 15 || cookies.get('customer_id') == 17))))
          && <i onClick={(e) => handleSyncReload(value)} className={`fa fa-refresh refresh-icon`} />
        } 
        <span>
          {value.isIQCFailed && (
            <>
              <TippyIcon
                onClick={(e) => handleIQCApprove(value)}
                iconClass="fa fa-check-circle icon-approve"
                tooltipText="Approve"
              />
              <TippyIcon
                onClick={(e) => handleIQCReject(e,value)}
                iconClass="fa fa-times-circle-o icon-reject"
                tooltipText="Reject"
              />
            </>
          )}
        </span>
        {value.download && (pageLayoutData[1].title1 === "PO INSPECT" || pageLayoutData[1].title1 === "QC") && <i onClick={(e) => handleDownload(value)} className={`fa fa-download-square-o fa-download refresh-icon`} />}
            </div>;  
      }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}


  async function tabChangeHandler(key, totalParams) {
    try{
    let getURL;
    let apiEndpoint = '';
    let responseDataJson = null;
  
    switch (key) {
      case pageLayoutData[1].subComponentsItems.tabName1:
      default:
        apiEndpoint = pageLayoutData[1].subComponentsItems.apiEndPoint1;
        totalParams = { ...totalParams, mode: key }
        break;
      case pageLayoutData[1].subComponentsItems.tabName2:
        apiEndpoint = pageLayoutData[1].subComponentsItems.apiEndPoint2;
        totalParams = { ...totalParams, mode: key }
        break;
    }
    setSelectedValue(1)
    setPageStartFrom(1)
  
    if (pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
      if(poInput){
        totalParams = {...totalParams,id: poInput}
      }
      const paramsConverted = new URLSearchParams(totalParams);
      getURL = `${apiEndpoint}?${paramsConverted.toString()}`;
  
        const responseData = await FetchAPI(getURL);
        handleNetworkErrors(responseData,setHasError);
        if(key === "download"){
          setValues("")
        }
        if(responseData.status == 200){
          setError(false);
          responseDataJson = await responseData.json();
          if(responseDataJson?.data?.Status){
            if(responseDataJson.data.Status == 409){
              swal({title: "No Data", text: responseDataJson.data.Message})
            }
          }
          setloadTableData(true);
          setProductsData(responseDataJson.data.data)
          setSyncPermission(responseDataJson.data.syncPermission)
        }
      setSelectOption(
        Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
      );
      settotalrecords(responseDataJson.data.recordsTotal);
      setError(false);
      if (responseDataJson.data.hasOwnProperty('addPermission')) {
        setAddButtonPermission(responseDataJson.data.addPermission);
      }
      if (!isEmpty(responseDataJson.data.data)) {
        if (pageLayoutData[0].addButtonType == 'modal') {
          modalActions(responseDataJson.data);
        }
      }
  
      if (key === pageLayoutData[1].subComponentsItems.tabName1) {
        setAssignedColumns(responseDataJson.data.columns);
        setAssignedProductsData(responseDataJson.data.data);
        setAssignedRecords(responseDataJson.data.recordsTotal);
      } else {
        setDownloadedColumns(responseDataJson.data.columns);
        setDownloadedProductsData(responseDataJson.data.data);
        setDownloadedRecords(responseDataJson.data.recordsTotal);
      }
      setformValues(pageLayoutData[0].formValues);
      setIotQty(pageLayoutData[1].title1 === 'Assign' ? responseDataJson.data.IOTQty : responseDataJson.data.availableQty)
      setDownloaded(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName2') && pageLayoutData[1].subComponentsItems.tabName2.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName2.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName2}Qty`]);
      setAssigned(responseDataJson.data[`${pageLayoutData[1].subComponentsItems.hasOwnProperty('tabName1') && pageLayoutData[1].subComponentsItems.tabName1.indexOf(' ') >= 0 ? pageLayoutData[1].subComponentsItems.tabName1.replace(/\s+/g, '') : pageLayoutData[1].subComponentsItems.tabName1}Qty`]);
      setloadTableData(true);
    }else {
      const response = await PostAPI(apiEndpoint, totalParams)
      if (key === pageLayoutData[1].subComponentsItems.tabName1) {
        setAssignedColumns(response.data.data.columns);
        setAssignedProductsData(response.data.data.data);
        setAssignedRecords(response.data.data.recordsTotal);
      } else {
        setDownloadedColumns(response.data.data.columns);
        setDownloadedProductsData(response.data.data.data);
        setDownloadedRecords(response.data.data.recordsTotal);
      }
      if (!isEmpty(response.data.data)) {
        if (pageLayoutData[0].addButtonType == 'modal') {
          modalActions(response.data.data);
        }
      }
      setloadTableData(true)
    }
    setIsLoading(false); 
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const fetchDispatchTimestamp = async () => {
    try{
    const queryParams = {
      type: `${pageLayoutData[1].title1} ${pageLayoutData[1].title2}`
    }
    const paramsConverted = new URLSearchParams(queryParams);
    const timestampEndpoint = `${pageLayoutData[0].timestampApi}`;
    const getURL = (`${timestampEndpoint}?${paramsConverted.toString()}`);
    const response = await FetchAPI(getURL);
    handleNetworkErrors(response,setHasError);
    const responseJson = await response.json();
    if(responseJson?.response?.status === 1){
      setTimeStamp(responseJson.response.time);
    }else{
      setTimeStamp("");
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  useEffect(() => {
    try{
    options.page = selectedValue;
    setpage(selectedValue);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }, [selectedValue]);

  useEffect(() => {
    try{
    if (pageLayoutData != 'undefined') {
    if (pageLayoutData && pageLayoutData[1] && pageLayoutData[1].hasOwnProperty('subComponentsItems')) {
      // set variables
      setformValues(pageLayoutData[0].formValues);
      setShowParentContent(true);
      setshowFilter(false);
      setloadTableData(false);
      setIsLoading(true); 
      setsearchInputValue('');
      setshowCSearch(false);
      setpage(1);
      let totalParams = {...dynamicParameters};
      if (pageLayoutData[1].subComponentsItems.extraParameters || pageLayoutData[1].subComponentsItems.firstTimeParameters) {
        totalParams = {
          ...totalParams,
          ...(pageLayoutData[1].subComponentsItems.extraParameters || {}),
          ...(pageLayoutData[1].subComponentsItems.firstTimeParameters || {})
        }
      }
      tabChangeHandler(key, totalParams);
      setPageStartFrom(1)
    }
    /*dispatch report timestamp*/
    let dispatchTimestampInterval;
    if (pageLayoutData[0]?.timestampApi && key === pageLayoutData[1].subComponentsItems.tabName1) {
      fetchDispatchTimestamp();
      dispatchTimestampInterval = setInterval(() => {
        fetchDispatchTimestamp();
      }, 5 * 60 * 1000)
    }
    return () => {
      clearInterval(dispatchTimestampInterval);
      setTimeStamp("");
    }
  }
}catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
  },[key,pageLayoutData]);

  useEffect(() => {
    if (key === pageLayoutData[1]?.subComponentsItems?.tabName1) {
      if (paginationAssigned.pageIndex !== 0) {
        handleLatestTableData(paginationAssigned.pageIndex)
      }
      if (paginationAssigned.pageIndex === 0 && isPageChanged) {
        handleLatestTableData(paginationAssigned.pageIndex)
      }
    }
  }, [paginationAssigned])

  useEffect(() => {
    if (key === pageLayoutData[1]?.subComponentsItems?.tabName2) {
      if (paginationDownloaded.pageIndex !== 0) {
        handleLatestTableData(paginationDownloaded.pageIndex)
      }
      if (paginationDownloaded.pageIndex === 0 && isPageChanged) {
        handleLatestTableData(paginationDownloaded.pageIndex)
      }
    }
  }, [paginationDownloaded])

  useEffect(() => {
    
      if (pagination.pageIndex !== 0) {
        handleLatestTableData(pagination.pageIndex)
      }
      if (pagination.pageIndex === 0 && isPageChanged) {
        handleLatestTableData(pagination.pageIndex)
      }
    
  }, [pagination])


  useEffect(() => {
    try{
    if(globalLoadIndicator == '2'){
      setPageLayoutData(pageLayoutDataContext);
      setKey(featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout[1].subComponentsItems.tabName1);
    }else if (globalLoadIndicator == '1'){
      setPageLayoutData('undefined');
    }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
  }, [globalLoadIndicator]);



  useEffect(() => {
    setsearchInputValue('')
    setPageStartFrom(1)
    setSelectedValue(1);
  },[key])



  
  async function exportPdf(e, url) {
    try{
    e.preventDefault();
    window.location.href = url;
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  async function exportFile(e,type) {
    try{
    e.preventDefault();
    let isdatesValuesNull
    let filterValues
    setFilterToExport(prevState => {
      return {
        ...prevState,
        change:true
      }
    })
    setIsLoader(true);
    let val;
    if(pageLayoutData[0].formValues) 
      val = pageLayoutData[0].formValues;
    else
      val = 'undefined';
    const searchFormData = {};
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name')
    }
    const getURL = pageLayoutData[0].exportApiEndPoint ? 
    pageLayoutData[0].exportApiEndPoint : 'not found';
    let newgetURL,getresponse,dataObject,getresponseJson;
    dataObject = {
      ...requiredValues
    }
    if(val !== 'undefined') {
      for (let formElementIdentifier in values) {
        searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
      }
      dataObject = {...dataObject, ...searchFormData}
      if(pageLayoutData[0].hasOwnProperty('extraParametersDropdown')) {
        const extraParametersDropdown = pageLayoutData[0].extraParametersDropdown;
        dataObject = {...dataObject, ...extraParametersDropdown}
      }
      if (type === "IOT Export") {
          dataObject = { ...dataObject, report_name: pageLayoutData[1].title1 }
          const endpoint = pageLayoutData[0]?.iotExportApiEndPoint
          setIsLoader(true);
          setIsLoading(true);
          const response = await PostAPI(endpoint, dataObject)
          handleNetworkErrors(response,setHasError);
          if (response.status === 200) {
            setIsLoader(false);
            setIsLoading(false);
            getStatusAlert({ status: response?.data?.status, message: response?.data?.message })
          } else {
            setIsLoader(false);
            setIsLoading(false);
            getStatusAlert({ status: 404, message: `${t("alerts.something_went_wrong1")}`, buttonText: `${t("alerts.ok")}` })
          }
        return;
      }
      else if (pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
        const paramString = new URLSearchParams(dataObject);
        setIsLoading(true)
        newgetURL = (`${getURL}?${paramString.toString()}`);
        if (cookies.get('customer_id') === '15' && JSON.stringify(searchFormData) !== JSON.stringify({})) {
          const selectedProperties = ["from_date", "to_date"];
          let labelKeys = Object.keys(searchFormData).filter((key) => !selectedProperties.includes(key))
          isdatesValuesNull = selectedProperties.map(propertyName => (
            {[propertyName]: searchFormData[propertyName]}))
            .every(obj => {
              for (const key in obj)
                if (!obj[key]) return false;
                else return true;
            });
          filterValues = labelKeys.map((el) => ({[el] : searchFormData[el]})).some(obj => {for (const key in obj)
          if (!obj[key]) return false;
          else return true
        })
          if (isdatesValuesNull) {
            getresponse = await FetchAPI(newgetURL);
            handleNetworkErrors(getresponse,setHasError);
            getresponseJson = await getresponse.json()
            setFilterToExport(prevState => {
              return {
                ...prevState,
                change: false
              }
            })
          }
          else if (searchFormData['from_date'] === '' && searchFormData['to_date'] === '') {
            getresponse = await FetchAPI(newgetURL);
            handleNetworkErrors(getresponse,setHasError);
            getresponseJson = await getresponse.json()
            setFilterToExport(prevState => {
              return {
                ...prevState,
                change: false
              }
            })
          }
          else if(filterValues ) {
            if(!searchFormData['from_date'] && !searchFormData['to_date']){
              getresponse = await FetchAPI(newgetURL);
              handleNetworkErrors(getresponse,setHasError);
              getresponseJson = await getresponse.json()
              setFilterToExport(prevState => {
                return {
                  ...prevState,
                  change: false
                }
              })
            }
            else {
              setFilterToExport(prevState => {
                return {
                  ...prevState,
                  change: true
                }
              })
            }
          }       
        }
        else {
          getresponse = await FetchAPI(newgetURL);
          handleNetworkErrors(getresponse,setHasError);
          getresponseJson = await getresponse.json()
        }
        setIsLoader(false);
        setIsLoading(false)
        if (getresponseJson?.data)
          window.location.href = getresponseJson?.data?.Location
      }
      else {
        getresponse = await PostAPI(getURL, dataObject);
        handleNetworkErrors(getresponse,setHasError);
      }
    } else {
      if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
        const paramString = new URLSearchParams(requiredValues);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        handleNetworkErrors(getresponse,setHasError);
      }
      else {
        getresponse = await PostAPI(getURL, requiredValues);
        handleNetworkErrors(getresponse,setHasError);
      }
    }
      if(cookies.get('customer_id') === '15'){
          if(getresponse?.status == 200){
            return swal('Your request is under process',
            'Shortly, you will receive an email with downlodable link','success')
        }
    }
    else if(getresponse?.status == 200){
        swal('Your request is under process',
        'Shortly, you will receive an email with downlodable link','success')
        if(getresponse?.data?.data?.Location){
          window.location.href =  getresponse?.data?.data?.Location
        }
    }
    else{
      swal('Something went wrong','Please download again','error')
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}


  async function exportFile1(e) {
    try{
    e.preventDefault();
    let val;
    if(pageLayoutData[0].formValues) 
      val = pageLayoutData[0].formValues;
    else
      val = 'undefined';
    const searchFormData = {};
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name')
    }
    const getURL = pageLayoutData[0].exportApiEndPoint1 ? 
    pageLayoutData[0].exportApiEndPoint1 : 'not found';
    let newgetURL,getresponse,dataObject;
    dataObject = {
      ...requiredValues
    }
    if(val !== 'undefined') {
      for (let formElementIdentifier in val) {
        searchFormData[formElementIdentifier] = val[formElementIdentifier].value;
      }
      dataObject = {...dataObject, ...searchFormData}
      if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
        const paramString = new URLSearchParams(dataObject);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        handleNetworkErrors(getresponse,setHasError);
      }
      else {
        getresponse = await PostAPI(getURL, dataObject);
        handleNetworkErrors(getresponse,setHasError);
      }
    } else {
      if(pageLayoutData[1].subComponentsItems.apiEndPointType1 === 'GET') {
        const paramString = new URLSearchParams(requiredValues);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        handleNetworkErrors(getresponse,setHasError);
      }
      else {
        getresponse = await PostAPI(getURL, requiredValues);
        handleNetworkErrors(getresponse,setHasError);
      }
    }
    if(getresponse.status == 200){
        swal('Your request is under process',
        'Shortly, you will receive an email with downlodable link','success')
        if(getresponse?.data?.data?.Location){
          window.location.href =  getresponse?.data?.data?.Location         
        }
    }
    else{
      swal('Something went wrong','Please download again','error')
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

const exportFile3 = async() => {
  const endpoint = pageLayoutData[0].exportApiEndPoint2
  const response = await PostAPI(endpoint, dynamicParameters)
  if(response.status === 200){
    swal('Your request is under process',
      'Shortly, you will receive an email with downlodable link','success')
      if(response?.data?.data?.Location){
        window.location.href = response.data.data.Location
      }
  }else{
    swal({
      icon: "error",
      text: "Something went wrong!"
    })
  }
}

  async function exportFile2(e) {
  try{  
  e.preventDefault();
  const getURL = pageLayoutData[0].exportApiEndPoint ? 
  pageLayoutData[0].exportApiEndPoint+'?customer_id='+cookies.get('customer_id') 
  + '&user_id='+ cookies.get('user_id')+ '&email='+ localStorage.getItem('email')
  + '&userLocation_id='+ cookies.get('userLocation_id')+ '&userRole_name='+ localStorage.getItem('userRole_name') : 'not found';
  const getresponse = await FetchAPI(getURL);
  handleNetworkErrors(getresponse,setHasError);
  if(getresponse.status == 200){
      swal('Your request is under process',
      'Shortly, you will receive an email with downlodable link','success')
  //window.location.href = "https://tertiary-label-printing.s3.amazonaws.com/OrientReports/2020-10-27/ProductionReport.xlsx";
  }
  else{
    swal('Something went wrong','Please download again','error')
  }
}catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
  }

  const generateTableData = (data) => {
    const columns = Object.keys(data[0]).map((key) => ({
      dataField: key,
      text: key.replace(/_/g, " ").toUpperCase(),
      headerStyle: { fontWeight: "900" } 
    }));
    const rows = data;
    return { columns, rows };
  };

  const expandRow = {
    renderer: (data) => {
      const row = data.original;
      if(pageLayoutData[1].title1 === "Inventory" && data.getIsExpanded()){
        return (
          <>
          <ExpandRowGrid
            pageLayoutData={pageLayoutData}
            serachFliterBoxData={searchTableData}
            dynamicParameters={dynamicParameters}
            response={key === pageLayoutData[1].subComponentsItems.tabName1 ? assignedProductsData : downloadedProductsData}
            row={row}
            values={values}
            pagination={pagination}
            setPagination={setPagination}
            title={pageLayoutData[1].title1 === 'Delivery' ? null : `Ageing ${pageLayoutData[1].title2}`}
            productsData={productsData}
            expandRow={expandRow}
            endpoint={pageLayoutData[1].subComponentsItems.expandEndpoint}
          />
          </>
        )
      }
      if (!row.childData?.length) {
        return <div style={{ textAlign: "center" }} >No data to display</div>
      }
      const { columns, rows } = generateTableData(row.childData)
      return (
        <div>
          <DataGrid
            rowData={rows}
            columns={transformColumns(columns)}
            paginationConfig={{ totalrecords: rows.length, setPagination, pagination, enablePagination: false }}
            globalSearchConfig={{
              enableGlobalFilter: false
            }}
          />
        </div>
      )
    },
  };

  const handlePoChange = (e) => {
    setPoInputChange(e.target.value)
  }

  const handlePoFieldSubmit = async () => {
    if(!poInputChange){
      swal("Please enter valid po number")
      return;
    }
    setPoInput(poInputChange);
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint1;
    const newObj = { ...dynamicParameters, id: poInputChange, mode: key }
    let paramsConverted = new URLSearchParams(newObj);
    getURL = (`${getURL}?${paramsConverted.toString()}`);
    setIsLoader(true);
    const response = await FetchAPI(getURL)
    const resonseJson = await response.json()
    if (!isEmpty(resonseJson.data.data)) {
      if (pageLayoutData[0].addButtonType == 'modal') {
        modalActions(resonseJson.data);
      }
    }
    setAssignedProductsData(resonseJson.data.data)
    setAssignedColumns(resonseJson.data.columns)
    setDownloadedColumns(resonseJson.data.columns)
    setDownloadedProductsData(resonseJson.data.data)
    setIsLoader(false);
    setExpandedRows([Number(poInputChange)]);
  }

  const poInspectSearchField = () => {
    return (
      <div className="po-inspect-field" >
        <input className="form-control" type="text" placeholder="Enter PO" onChange={handlePoChange}/>
        <button 
        disabled={isLoader} 
        className="btnCls" 
        style={{
          backgroundColor: '#f9c900',
          color: '#151718',
          textAlign: 'center',
          minWidth:'70px'
      }}
      onClick={handlePoFieldSubmit} >Submit</button>
      </div>
    )
  }

  const options = {
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    sizePerPage: sizePerPage,
    page: page,
    totalSize: key === pageLayoutData[1]?.subComponentsItems?.tabName1 ? assignedRecords : downloadedRecords
  }

  const RemotePagination = ({ data, page, sizePerPage, onTableChange, totalSize, baseValue }) => (
    <div>
      <BootstrapTable
        remote
        keyField="id"
        striped
        hover
        condensed
        bordered={false}
        {...baseValue}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        noDataIndication={`${t("no_data")}`}
        wrapperClasses="table-responsive overflow-class"
        headerClasses="grid-header"
      />
    </div>
  );

  if (hasError.error) {
    return <ErrorFallback error={hasError.message} />
  }  

return (
  (pageLayoutData != 'undefined' && cookies.get('pagetype_id') == 17) ?
  <div className="content" >
        <Grid fluid>
          <Row>
            <Col md={12} style={{ marginTop: '0px' }}>
              <Card style={{ fontSize: '12px' }}
                hCenter = {(`${t(pageLayoutData[1].title3)} : `)}
                iotQty = {iotQty}
                button ={(pageLayoutData[0].addButton === true && pageLayoutData[0].addButtonType == 'modal') ? <ButtonField color="info" submit={() => open()} BName={(pageLayoutData[1].title2 === 'Bulk Download' || pageLayoutData[1].title1 === 'Assign'  ? '':`${t('download')} `) + t(pageLayoutData[0].addButtonName)} /> : ''}
                title={(pageLayoutData[1]) ? t(pageLayoutData[1].title1) : ''}
                title2={(pageLayoutData[1]) ? t(pageLayoutData[1].title2) :''}
                timeStamp={timeStamp}
            content={
              <>
              { pageLayoutData[1].title1 === "PO INSPECT" && poInspectSearchField()}
                 <Tabs
                     id="controlled-tab-example"
                      // activeKey={key}
                      onSelect={(k) => setKey(k)}
                      className="mb-3"
                      justify
                      defaultActiveKey={key}
                  >
                  <Tab eventKey={pageLayoutData[1].subComponentsItems.tabName1} title={t(pageLayoutData[1].subComponentsItems.apiTabName1)}  >
                    {showModal &&
                        <ModalBox
                          key={ pageLayoutData[0].featureId }
                          showModal={showModal}
                          titlePreFix = { modalType }
                          modalWidth = { modalWidth}
                          // title={pageLayoutData[0].addButtonName}
                          title={ modalTitle }
                          formValue={ModalformValues}
                          addURL={ saveUrl }
                          getURL={ modalgetURL }
                          uniqueid={ uniqueId }
                          commonTitle = {commonTitle}
                          extraId = {extraId}
                          prop = {prop}
                          drpdwnApi = {pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? dropDownApi : 'not found' }
                          recallMehod= { getLatestTableData }
                          hide={close} 
                          headers = {headers}
                          table = {table}
                          mode = {pageLayoutData[1].subComponentsItems.extraParameters.mode}
                          setHasError={setHasError}
                        />}
                {showParentContent &&
                        <div>
                          <Row>
                            {pageLayoutData[1].subComponentsItems.isQuantity === false ? null : 
                            <Col md="2" className="mb-6" style={{ width : "fit-content" , margin:"6px 12px" }}>
                            <div className="custom-form-cntrl">
                                <label htmlFor="" adjustsFontSizeToFit={true} numberOfLines={1}  style={textStyles}>{`${t('total')}  ${t(pageLayoutData[1].subComponentsItems.apiTabName1)}`}</label>
                                <input type="text"  className="form-control" readOnly="readOnly" style={{marginTop:"-7px", width: "15rem"}} value={assigned}/>
                                </div>
                            </Col>
                            }
                          <Col md="12" className="mb-12">
                            {loadTableData &&
                              <div className="button-container">
                                {((pageLayoutData[0].exportButton === true && pageLayoutData[0].filterStatus === false)) ? <ButtonField color="info" submit={(e) => exportFile2(e)} BName={`${t("export_csv")} `} /> : ''}
                                {(pageLayoutData[0].exportButton === true && pageLayoutData[0].filterStatus === true) ? <ButtonField color="info" submit={(e) => exportFile(e)} BName={`${pageLayoutData[0]?.exportButtonName ? pageLayoutData[0]?.exportButtonName : t("export_csv")}`} /> : ''}
                                {(pageLayoutData[0].iotExportButton === true && <ButtonField color="info" submit={(e) => exportFile(e,"IOT Export")} BName={"IOT Export"} />)}
                                {(pageLayoutData[0].exportButton1 === true) ? <ButtonField color="info" submit={(e) => exportFile1(e)} BName={`${t("export")} `+ pageLayoutData[0].exportButtonName1} /> : ''}
                                {(pageLayoutData[0].exportButton2 === true) ? <ButtonField color="info" submit={(e) => exportFile3(e)} BName={`${t("export")} `+ pageLayoutData[0].exportButtonName2} /> : ''}
                                {(pageLayoutData[0].filterStatus === true) ? <ButtonField color="info" type={t("filter")} key="Filter" submit={() => openFilter()} BName={`${t("filter")} `} /> : ''}
                                {(pageLayoutData[0].importButton === true) ? <ButtonField color="info" submit={() => openImport()} BName={`${t("import")} `+ pageLayoutData[0].importButtonName} /> : ''}
                                {(pageLayoutData[0].importButton1 === true) ? <ButtonField color="info" submit={() => openImport1()} BName={`${t("import")} `+ pageLayoutData[0].importButtonName1} /> : ''}
                              </div>}
                            </Col>
                          </Row>
                            {showFilter &&
                            <div className="filter-box">
                              <FilterBox
                                key="FilterBox"
                                formValue={formValues}
                                setformValues = { setformValues }
                                setSelectChildValue={setSelectChildValue}
                                change={inputChangedHandler}
                                searchClick={ searchTableData }
                                filteredExport = {filteredExport}
                                filteredExport1 = {filteredExport1}
                                filteredExport2 = {filteredExport2}
                                filterToExport = {filterToExport}
                                setFilterToExport = {setFilterToExport}
                                selectChildValue={selectChildValue}
                                clearClick={clearTableData}
                                title={pageLayoutData[1].title1}
                                dropDownApi = {dropDownApi}
                                validate={validator} 
                                exportFilterButton={pageLayoutData[0].exportFilterButton === true ? true : false}
                                exportFilterButton1={pageLayoutData[0].exportFilterButton1 === true ? true : false}
                                exportFilterButtonName1={pageLayoutData[0].hasOwnProperty('exportFilterButtonName1') === true ? pageLayoutData[0].exportFilterButtonName1 : ''}
                                exportApiEndPoint={pageLayoutData[0].exportApiEndPoint ? 
                                pageLayoutData[0].exportApiEndPoint : 'not found'}
                                setHasError={setHasError}
                              />
                            </div>
                            }
                            {showParentContent &&
                            <div>
                            <DataGrid
                                  rowData={assignedProductsData}
                                  columns={transformColumns(assignedColumns)}
                                  isLoading={isLoading}
                                  paginationConfig={{
                                    totalrecords: assignedRecords,
                                    pagination: paginationAssigned,
                                    setPagination: setPaginationAssigned
                                  }}
                                  rowExpandConfig={{enableRowExpansion: pageLayoutData[1]?.subComponentsItems?.isExpand, expandRow}}
                                  globalSearchConfig={{
                                    enableGlobalFilter: true,
                                    placeholder: pageLayoutData[1].title1,
                                    handleGlobalSearch,
                                    handleClearSearch,
                                  }}
                                  title={`${pageLayoutData[1].title1} ${pageLayoutData[1].title2}`}
                                />
                                </div>
                            }
                          </div>
                        
                }
                </Tab>
                <Tab eventKey={pageLayoutData[1].subComponentsItems.tabName2} title={t(pageLayoutData[1].subComponentsItems.apiTabName2)}>
                {showParentContent &&
                        <div>
                          <Row>
                            {/* <MDBContainer style={{ height: '10rem' }}> */}
                            {pageLayoutData[1].subComponentsItems.isQuantity === false ? null :
                            <Col md="2" className="mb-6" style={{ width : "fit-content", margin:"6px 12px"}}>
                            <div className="custom-form-cntrl">
                                <label htmlFor="" adjustsFontSizeToFit={true} numberOfLines={1}  style={textStyles}>{`${t('total')} ${t(pageLayoutData[1].subComponentsItems.apiTabName2)}`}</label>
                                <input type="text"  className="form-control" readOnly="readOnly" style={{marginTop: "-7px", width: "15rem"}} value={downloaded}/>
                                </div>
                            </Col>}
                            <Col md="12" className="mb-12">
                            {loadTableData &&
                              <div className="button-container">
                                {((syncPermission === true && pageLayoutData[1].title1 == "Inventory Sync to")) ? <button disabled={disabledButton} onClick={(event) => syncInventory(event)} class="button-styles">{'Sync Data'}</button> : ''}
                                 {((pageLayoutData[1].subComponentsItems.tabName2 !== "download" && pageLayoutData[0].exportButton === true && pageLayoutData[0].filterStatus === false)) ? <ButtonField color="info" submit={(e) => exportFile2(e)} BName={`${t("export_csv")} `} /> : ''}
                                {(pageLayoutData[1].subComponentsItems.tabName2 !== "download" && pageLayoutData[0].exportButton === true && pageLayoutData[0].filterStatus === true) ? <ButtonField color="info" submit={(e) => exportFile(e)} BName={`${t("export_csv")} `} /> : ''}
                                {(pageLayoutData[0].exportButton1 === true && pageLayoutData[1].subComponentsItems.tabName2 !== "download") ? <ButtonField color="info" submit={(e) => exportFile1(e)} BName={'Export '+ pageLayoutData[0].exportButtonName1} /> : ''}
                                {(pageLayoutData[1].subComponentsItems.tabName2 !== "download" && pageLayoutData[0].filterStatus === true) ? <ButtonField color="info" type={t("filter")} key="Filter" submit={() => openFilter()} BName={`${t("filter")} `} /> : ''}
                                {(pageLayoutData[0].importButton === true) ? <ButtonField color="info" submit={() => openImport()} BName={`${t("import")} `+ t(pageLayoutData[0].importButtonName)} /> : ''}
                                {(pageLayoutData[0].importButton1 === true) ? <ButtonField color="info" submit={() => openImport1()} BName={`${t("import")} `+ t(pageLayoutData[0].importButtonName1)} /> : ''}
                              </div>}
                          </Col>
                          </Row>
                            {pageLayoutData[1].title1 !== "Dispatch" && showFilter &&
                              <FilterBox
                                key="FilterBox"
                                formValue={formValues}
                                setformValues = { setformValues }
                                setSelectChildValue={setSelectChildValue}
                                change={inputChangedHandler}
                                searchClick={ searchTableData }
                                filteredExport = {filteredExport}
                                filteredExport1 = {filteredExport1}
                                filteredExport2 = {filteredExport2}
                                selectChildValue={selectChildValue}
                                clearClick={clearTableData}
                                title={pageLayoutData[1].title1}
                                dropDownApi = {dropDownApi}
                                validate={validator} 
                                exportFilterButton={pageLayoutData[0].exportFilterButton === true ? true : false}
                                exportFilterButton1={pageLayoutData[0].exportFilterButton1 === true ? true : false}
                                exportFilterButtonName1={pageLayoutData[0].hasOwnProperty('exportFilterButtonName1') === true ? pageLayoutData[0].exportFilterButtonName1 : ''}
                                exportApiEndPoint={pageLayoutData[0].exportApiEndPoint ? 
                                pageLayoutData[0].exportApiEndPoint : 'not found'}
                                setHasError={setHasError}
                              />}
                            {showParentContent &&
                              <>
                             <DataGrid
                                  rowData={downloadedProductsData}
                                  columns={transformColumns(downloadedColumns)}
                                  isLoading={isLoading}
                                  paginationConfig={{
                                    totalrecords: downloadedRecords,
                                    pagination: paginationDownloaded,
                                    setPagination: setPaginationDownloaded
                                  }}
                                  globalSearchConfig={{
                                    enableGlobalFilter: true,
                                    placeholder: pageLayoutData[1].title1,
                                    handleGlobalSearch,
                                    handleClearSearch,
                                  }}
                                />
                            </>}
                      </div>}
                </Tab>
                <Tab eventKey={pageLayoutData[1].subComponentsItems.tabName3} title={t(pageLayoutData[1].subComponentsItems.apiTabName3)}>
                {showParentContent &&
                        <div>
                              <DataGrid
                                  rowData={downloadedProductsData}
                                  columns={transformColumns(downloadedColumns)}
                                  isLoading={isLoading}
                                  paginationConfig={{
                                    totalrecords: downloadedRecords,
                                    pagination: paginationDownloaded,
                                    setPagination: setPaginationDownloaded
                                  }}
                                  rowExpandConfig={{ enableRowExpansion: false }}
                                  globalSearchConfig={{
                                    enableGlobalFilter: true,
                                    placeholder: pageLayoutData[1].title1,
                                    handleGlobalSearch,
                                    handleClearSearch,
                                  }}
                                />
                          </div>}
                </Tab>
                  </Tabs>
                  </>
                }
          />
          {showTPModal &&
                  <Modal show={showTPModal} onHide={closeTPModal} dialogClassName={"modal-90w"} backdrop="static" keyboard={false}>
                    <Modal.Header closeButton className="modal-close-button" >
                      <Modal.Title>{tpPermission && "TP:"}
                        <a href='#!' className='font-weight-bold' style={{color:'white'}}>
                          <strong> {modalTitle}</strong>
                        </a>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                  <Row>
                    <Col md={tpPermission ? "4" : "12"} className="mb-4">
                      {loadTableDataChild ? 
                      pageLayoutData[1].title1 === "Internal Quality Check" ? 
                      <KeyValueContainer rowData={productsDataChild} columns={columnsChild} /> :
                        <div className="">
                          <DataGrid 
                          rowData={productsDataChild} 
                          columns={transformColumns(columnsChild)}
                          paginationConfig={{
                            totalrecords: productsDataChild.length,
                            setPagination,
                            pagination,
                            enablePagination: false
                          }}
                          globalSearchConfig={{
                            enableGlobalFilter: false
                          }}
                          />
                          <div style={{display: "flex", justifyContent: "space-between", marginTop: '1rem'}}>
                          {(syncSapMessage.status === "Sync failed" && syncSapMessage.message) && 
                            <div className="sync-sap-message" >
                            <p>
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {syncSapMessage.message}</p></div>}
                            <ButtonField submit={closeTPModal} color="info" BName="Close" />
                          </div>
                        </div>
                        :
                        null
                      }
                    </Col>
                    <Col md="8" className="mb-8"  >
                    </Col>
                  </Row>
                </Modal.Body>
                  </Modal>}
            </Col>
          </Row>
        </Grid>
      </div>
      : <div className="content">
      <Grid fluid>
        <div className="text-center" style={{ margin:"80px" }}><LoadingSpinner /></div>
      </Grid>
    </div>
  );
}

export default Role;

